import React from 'react';
import { useLoadingContext } from '../contexts/LoadingContext';

const Loading = () => {
  const { loading } = useLoadingContext();

  if (!loading) return null;

  return (
    <div 
      id="loading" 
      className="modal is-active"
      style={{
        backdropFilter: 'blur(8px)',
        background: 'rgba(0, 0, 0, 0.4)'
      }}
    >
      <div className="modal-background"></div>
      <div className="modal-content">
        <div 
          className="box has-text-centered"
          style={{
            borderRadius: '20px',
            background: 'rgba(255, 255, 255, 0.95)',
            backdropFilter: 'blur(20px)',
            border: '1px solid rgba(255, 255, 255, 0.3)',
            boxShadow: '0 25px 50px rgba(0, 0, 0, 0.15)',
            padding: '3rem',
            maxWidth: '400px',
            margin: '0 auto'
          }}
        >
          {/* Loading Spinner Moderno */}
          <div className="mb-5">
            <div className="modern-spinner">
              <div className="spinner-ring"></div>
              <div className="spinner-ring"></div>
              <div className="spinner-ring"></div>
            </div>
          </div>

          {/* Texto */}
          <h3 className="title is-5 has-text-grey-dark mb-2">
            Cargando
          </h3>
          <p className="has-text-grey">
            Por favor espera un momento...
          </p>

          {/* Barra de progreso animada */}
          <div className="mt-4">
            <div className="progress-container">
              <div className="progress-bar"></div>
            </div>
          </div>
        </div>
      </div>

      {/* Estilos CSS integrados */}
      <style jsx>{`
        /* Spinner moderno con anillos */
        .modern-spinner {
          position: relative;
          width: 60px;
          height: 60px;
          margin: 0 auto;
        }

        .spinner-ring {
          position: absolute;
          width: 100%;
          height: 100%;
          border: 3px solid transparent;
          border-radius: 50%;
          animation: spin 2s linear infinite;
        }

        .spinner-ring:nth-child(1) {
          border-top-color: #667eea;
          animation-delay: 0s;
        }

        .spinner-ring:nth-child(2) {
          border-top-color: #764ba2;
          animation-delay: 0.3s;
          transform: scale(0.8);
        }

        .spinner-ring:nth-child(3) {
          border-top-color: #f093fb;
          animation-delay: 0.6s;
          transform: scale(0.6);
        }

        @keyframes spin {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }

        /* Barra de progreso animada */
        .progress-container {
          width: 100%;
          height: 4px;
          background-color: #e0e0e0;
          border-radius: 2px;
          overflow: hidden;
        }

        .progress-bar {
          height: 100%;
          background: linear-gradient(90deg, #667eea, #764ba2, #f093fb);
          background-size: 200% 100%;
          border-radius: 2px;
          animation: progressMove 2s ease-in-out infinite;
        }

        @keyframes progressMove {
          0% {
            transform: translateX(-100%);
            opacity: 0.6;
          }
          50% {
            opacity: 1;
          }
          100% {
            transform: translateX(100%);
            opacity: 0.6;
          }
        }

        /* Animación de entrada */
        .modal.is-active .modal-content {
          animation: fadeInScale 0.3s ease-out;
        }

        @keyframes fadeInScale {
          from {
            opacity: 0;
            transform: scale(0.8) translateY(20px);
          }
          to {
            opacity: 1;
            transform: scale(1) translateY(0);
          }
        }

        /* Responsive */
        @media screen and (max-width: 768px) {
          .modal-content .box {
            margin: 1rem;
            padding: 2rem !important;
          }
        }
      `}</style>
    </div>
  );
};

export default Loading;